import { useState } from 'react';

const navLinks = [
  { label: '深扒速览', href: '#feed' },
  { label: '话题墙', href: '#topics' },
  { label: '时间线还原', href: '#timeline' },
  { label: '逐层拆解', href: '#layers' },
  { label: '互动区', href: '#community' },
];

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full">
      <div className="hidden md:block border-b border-background-200 bg-background-100">
        <div className="px-4 md:px-6 lg:px-10 h-9 flex items-center justify-between text-xs text-foreground-600">
          <p className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-dot"></span>
            今日新增深扒长图 28 组，时间线已更新至 T+2 天
          </p>
          <div className="flex items-center gap-5 font-label">
            <a href="#timeline" className="hover:text-primary-600 transition-colors">还原时间线</a>
            <a href="#layers" className="hover:text-primary-600 transition-colors">拆解层级</a>
            <a href="#community" className="hover:text-primary-600 transition-colors">参与讨论</a>
          </div>
        </div>
      </div>

      <nav className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
        <div className="px-4 md:px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
              黑
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">黑料图文</span>
              <span className="text-[10px] tracking-[0.22em] text-foreground-500 font-label mt-1">DEEP DIVE ARCHIVE</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-7 text-sm font-label">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
                {link.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2.5">
            <div className="hidden md:flex items-center gap-2 h-9 px-3 rounded-md border border-background-300 bg-background-100 focus-within:border-primary-400 transition-colors">
              <span className="w-4 h-4 flex items-center justify-center text-foreground-500">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                placeholder="搜索话题 / 时间线 / 长图"
                className="bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none w-40 xl:w-52 font-label"
              />
            </div>
            <a
              href="#subscribe"
              className="hidden sm:flex items-center h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              订阅深扒
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 md:px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-2.5 text-sm font-label text-foreground-800 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium"
            >
              订阅深扒
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}